import { defineComponent, useContext, watch } from '@nuxtjs/composition-api';
import { useModal, useUser } from '~/composables';
import { SCANNER_CONTEXT } from '~/pages/scanner/data';
import { createHead } from '~/utils';
export default defineComponent({
    name: 'PageScannerOauth',
    setup() {
        const context = useContext();
        const modal = useModal();
        const user = useUser();
        const data = {
            ...SCANNER_CONTEXT.auth,
            button: {
                ...SCANNER_CONTEXT.auth?.button,
                action: () => {
                    modal.open('signIn');
                },
            },
        };
        watch(() => user.info, () => {
            if (user.isAuthorized) {
                context.redirect(301, '/scanner');
            }
        });
        return {
            data,
        };
    },
    asyncData(context) {
        const { app, env, error, route, redirect } = context;
        const user = useUser();
        if (user.isAuthorized) {
            redirect(301, '/scanner');
        }
        try {
            const title = 'Сканер иноагентов, причастных к экстремизму и терроризму и организаций, признанных нежелательными';
            const head = {
                canonical: env.HOST + route.path,
                title,
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            return {
                $page: context.$page,
                head,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head);
    },
});
